import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import OptimizeImagesService from 'services/OptimizeImages.service';

import messages from './FileToDownload.intl';
import styles from './FileToDownload.module.scss';

@injectIntl
export default class FileToDownloadComponent extends Component {
  static defaultProps = {
    className: ''
  };

  static propTypes = {
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    hideImg: PropTypes.bool
  };

  render() {
    const { className, url, title, size, hideImg } = this.props;
    const computedSize = Math.round(size / 1024);

    return (
      <div className={`${styles.FileToDownload} ${className}`}>
        {!hideImg && (
          <img
            src={OptimizeImagesService.adjustImageSize(url)}
            alt="File to download"
            className={styles.FileToDownloadImage}
          />
        )}
        <div className={styles.ContainerContactInfo}>
          <div className={styles.FileInfo}>
            <span className={styles.FileToDownloadNameSpan}>{title}</span>
            <div className={styles.FileToDownloadCompanyInfo}>
              <span className={styles.FileToDownloadValue}>
                ({computedSize}kb)
              </span>
            </div>
          </div>
          <span className={styles.DownloadSpan}>
            <a href={url} target="_blank" rel="noopener noreferrer" download>
              {this.props.intl.formatMessage(messages.download)}
            </a>
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/FileToDownload/FileToDownload.js